import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopConfigurationItemOptionActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ItemOption/ItemOptionBrowser")
	}

	render() {
		return (
			<Activity 
				name="ItemOption"
				RenderedComponent={this.RenderedComponent}
				context="ItemOption"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopConfigurationItemOptionActivity)
